import { render, staticRenderFns } from "./FieldArrangement.vue?vue&type=template&id=361aaeb4&scoped=true&lang=pug"
import script from "./FieldArrangement.vue?vue&type=script&lang=js"
export * from "./FieldArrangement.vue?vue&type=script&lang=js"
import style0 from "./FieldArrangement.vue?vue&type=style&index=0&id=361aaeb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361aaeb4",
  null
  
)

export default component.exports